import React, { useEffect } from 'react';
import {
  DetailsList,
  IDetailsListProps,
  CheckboxVisibility,
  IColumn,
  Checkbox,
  ConstrainMode,
  ScrollablePane,
  ScrollbarVisibility,
  Sticky,
  StickyPositionType,
} from '@fluentui/react';
import '../css/controll/noDataFound.scss';
import styled from 'styled-components';
interface NoDataFoundProps {
  props: IDetailsListProps;
  itemChecked?: any[];
}
const TeuDetailList = styled.div`
  position: relative;
  .ms-DetailsHeader-cell {
    span:first-child {
      display: flex;
      align-items: center;
    }
  }
`;
let isCheckAll: boolean = false;
export const TeuDetailsList = ({ props, itemChecked }: NoDataFoundProps) => {
  const [isCheckAllClick, SetIsCheckAllClick] = React.useState({ checked: false });
  const [ItemCheckChange, SetItemCheckChange] = React.useState<{ item: any; checked: boolean }>();
  const [Items, SetItems] = React.useState<any[]>([]);
  let columns = props.columns || [];
  if (columns && props.checkboxVisibility !== CheckboxVisibility.hidden) {
    let checkBox = columns.find((o) => o.key === 'Checkbox');
    if (!checkBox) {
      columns.unshift({
        key: 'Checkbox',
        className: 'flex-center',
        maxWidth: 30,
        minWidth: 30,
        onRender: (item, i, column) => {
          return (
            <>
              <Checkbox
                checked={item.checked ? true : false}
                onChange={(e, checked) => {
                  item.checked = checked;
                  SetItemCheckChange({ item: item, checked: checked || false });
                }}
              ></Checkbox>
            </>
          );
        },
        onRenderHeader: () => {
          return (
            <>
              <Checkbox
                checked={isCheckAll ? true : false}
                className="check1"
                onChange={(e, checked) => {
                  SetIsCheckAllClick({ checked: checked || false });
                }}
              ></Checkbox>
            </>
          );
        },
      } as IColumn);
    }
  }
  useEffect(() => {
    Items.forEach((o) => {
      o.checked = isCheckAllClick.checked;
    });
    SetItems([...Items]);
    isCheckAll = isCheckAllClick.checked ? true : false;
  }, [isCheckAllClick]);
  useEffect(() => {
    const items = props.items;
    SetItems(items);
    isCheckAll = false;
    isCheckAllClick.checked = false;
  }, [props.items]);
  useEffect(() => {
    if (ItemCheckChange) {
      Items.forEach((o) => {
        if (o === ItemCheckChange.item) {
          o.checked = ItemCheckChange.checked;
        }
      });
      isCheckAll = Items.filter((o) => o.checked === true).length === Items.length;
      SetItems([...Items]);
    }
  }, [ItemCheckChange]);
  return (
    <TeuDetailList style={((props.styles as any) || { root: { minHeight: 400 } }).root}>
      <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
        <DetailsList
          items={Items}
          columns={columns}
          checkboxVisibility={CheckboxVisibility.hidden}
          constrainMode={ConstrainMode.unconstrained}
          onRenderRow={props.onRenderRow}
          onRenderDetailsHeader={(headerProps, defaultRender) => {
            if (defaultRender && headerProps) {
              return (
                <Sticky
                  stickyPosition={StickyPositionType.Header}
                  isScrollSynced={true}
                  stickyBackgroundColor="transparent"
                >
                  {defaultRender(headerProps)}
                </Sticky>
              );
            } else {
              return <></>;
            }
          }}
        />
      </ScrollablePane>
    </TeuDetailList>
  );
};
